import React from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import BodyBlocker from "./BodyBlocker";
import SidebarPanel from "./SidebarPanel";
import {areaSelectorClose, areaSelectorSelectArea} from '../actions/creators/ui';
import {getAreaBillboardPermalink,getStateBillboardPermalink} from '../utils/urls';
import {sortByProperty} from '../utils/arrays';
import {getAreasById,getStates,getStatesById,getUiAreaSelectorOptions,isUiAreaSelectorOpen} from '../reducers';
import BackButton from './common/BackButton';

type Area = {
  id:number|string,
  name:string,
};

type StateEntity = {
  id:number,
  name:string,
  areas:Area[],
}

type Props = {
  areaId: number|string,
  areas: Area[],
  history: any,
  open: boolean,
  states: StateEntity[],
  statesById: { [key:string]: StateEntity },
  onAreaSelect: (type: string, id: number, args?: { [key: string]: any }) => void,
  onClose: () => void,
  options: {
    allowFullState:boolean,
    context:string,
  },
};

type State = {
  areaId:number|string,
};

const AreaSelector = (props: Props) => {
  const [areaId, setAreaId] = React.useState(props.areaId || 0);

  const getAreas = (): StateEntity[] => {
    return props.states.map((state) => {
      const areas = Object.values(state.areas).sort(sortByProperty('name'));

      if (props.options.allowFullState !== false && areas.length > 1) {
        areas.splice(0, 0, { id: 'state-' + state.id, name: 'Todo ' + state.name });
      }

      return {
        id: state.id,
        name: state.name,
        areas,
      };
    });
  }

  const selectArea = (e) => {
    let areaId = e.target.value;
    let type = 'area';

    if (props.options.context !== 'landing') {
      const stateMatch = areaId.match(/^state-(\d+)$/);
      const currentPath = document.location.pathname;
      let newPath;

      if (stateMatch !== null) {
        areaId = parseInt(stateMatch[1], 10);
        type = 'state';
        const state = props.statesById[areaId];
        newPath = getStateBillboardPermalink(state);
      } else {
        areaId = parseInt(areaId, 10);
        const area = props.areas[areaId];
        newPath = getAreaBillboardPermalink(area);
        props.history.push(getAreaBillboardPermalink(area));
      }

      props.history.push(
          currentPath.replace(/^\/cartelera\/(zona|estado)-\d+\/[^\/]+/, newPath)
      );
    }

    props.onAreaSelect(type, areaId, props.options.context ? { context: props.options.context } : undefined);
    props.onClose();
  }

  if (!props.open) {
    return '';
  }

  return (
    <React.Fragment>
      <BodyBlocker />
      <SidebarPanel overBlocker={true}>
        <div className="container pad-y h-100">
          <h3 className="h5 mb-5">
            <BackButton label='Escoge una zona para ver su cartelera' onBackClick={(e) => props.onClose()}/>
          </h3>

          <form action="">
            <div className="form-group mb-5">
              <label htmlFor="preferencesZona">Tu zona</label>
              <select className="form-control" id="preferencesZona" onChange={selectArea} value={areaId}>
                <option key="0" value="0">Selecciona tu zona</option>
                {getAreas().map((state) => state.areas.length
                  ? <optgroup key={state.id} label={state.name}>{state.areas.map((area) => <option value={area.id} key={area.id}>{area.name}</option>)}</optgroup>
                  : ''
                )}
              </select>
            </div>
          </form>
        </div>
      </SidebarPanel>
    </React.Fragment>
  );
}

const mapStateToProps = (state, props) => ({
  areas: getAreasById(state),
  open: props.open || isUiAreaSelectorOpen(state),
  options: props.options || getUiAreaSelectorOptions(state),
  states: getStates(state),
  statesById: getStatesById(state),
});

const mapDispatchToProps = (dispatch, props) => ({
  onAreaSelect: props.onAreaSelect || ((type: string, id: number, args?: { [key: string]: any }) => dispatch(areaSelectorSelectArea(type, id, args))),
  onClose: props.onClose || (() => dispatch(areaSelectorClose())),
});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(AreaSelector));